import { useEffect, useState } from 'react';

const media = {
	xs: '(width < 480px)',
	sm: '(width < 576px)',
	md: '(width < 768px)',
	lg: '(width < 992px)',
	xl: '(width < 1200px)',
	xxl: '(width < 1600px)',
};

export const useMedia = (key: keyof typeof media = 'md') => {
	const query = media[key];
	const [isNarrowScreen, setIsNarrowScreen] = useState(false);
	useEffect(() => {
		const mediaWatcher = window.matchMedia(query);
		setIsNarrowScreen(mediaWatcher.matches);

		function updateIsNarrowScreen(e: MediaQueryListEvent) {
			setIsNarrowScreen(e.matches);
		}

		mediaWatcher.addEventListener('change', updateIsNarrowScreen);
		return function cleanup() {
			mediaWatcher.removeEventListener('change', updateIsNarrowScreen);
		};
	}, [query]);

	return isNarrowScreen;
};
